import React from 'react';
import ReactTooltip from 'react-tooltip';

function ProjectHeaderButton({ id, tip, tooltipClass, className, iconClass, onClick }) {
    return <div className={`action-btn light-blue-with-border main-header-btn ${className}`}
        data-for={id}
        data-tip={tip}
        data-place="bottom"
        data-effect="solid"
        data-class={`tutor-light-tooltip tutor-no-arrow-tooltip ${tooltipClass}`}
        onClick={onClick}>
        {id && <ReactTooltip id={id} />}
        <i className={`icon ${iconClass}`} />
    </div>;
}

export default ProjectHeaderButton;